import { render, staticRenderFns } from "./SchoolLayoutDataCenter.vue?vue&type=template&id=622c249e&scoped=true&"
import script from "./SchoolLayoutDataCenter.vue?vue&type=script&lang=js&"
export * from "./SchoolLayoutDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLayoutDataCenter.vue?vue&type=style&index=0&id=622c249e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c249e",
  null
  
)

export default component.exports